import React, { FunctionComponent } from 'react';
import { Superscript } from 'components/Superscript';
import { Text } from 'components/chroma';
import { CoverType, FunnelType } from 'scenes/common/types';
import { MotorCoverType } from 'scenes/motor/types';

const COVER_DESCRIPTION: {
  [key in FunnelType]?: { [key in CoverType | MotorCoverType]?: string };
} = {
  [FunnelType.Home]: {
    [CoverType.Building]: 'Home Building Insurance',
    [CoverType.Contents]: 'Home Contents Insurance',
    [CoverType.BuildingAndContents]: 'Home Building & Contents Insurance',
  },
  [FunnelType.Motor]: {
    [MotorCoverType.Comprehensive]: 'Comprehensive Car Insurance',
    [MotorCoverType.ThirdPartyFireAndTheft]:
      'Third Party Property Damage, Fire & Theft Car Insurance',
    [MotorCoverType.ThirdPartyPropertyDamage]:
      'Third Party Property Damage Car Insurance',
  },
  [FunnelType.Landlord]: {
    [CoverType.Building]: 'Landlord Building Insurance',
    [CoverType.Contents]: 'Landlord Contents Insurance',
    [CoverType.BuildingAndContents]: 'Landlord Building & Contents Insurance',
  },
};

const showGetRewarded = (coverType: MotorCoverType | CoverType) =>
  coverType !== MotorCoverType.ThirdPartyFireAndTheft &&
  coverType !== MotorCoverType.ThirdPartyPropertyDamage;

const FlybuysHelpText: FunctionComponent<{
  productType: FunnelType;
  coverType: MotorCoverType | CoverType;
}> = ({ productType, coverType }) => (
  <>
    <Text>
      Don&apos;t worry, you can still get a quote or buy a policy without adding
      a Flybuys number, the quote price won&apos;t change.
    </Text>
    {showGetRewarded(coverType) && (
      <Text>
        Get rewarded - Flybuys members who link their membership number to a
        Coles {COVER_DESCRIPTION[productType]?.[coverType]} policy can collect
        double points at Coles Supermarkets.
        <Superscript>#</Superscript>
      </Text>
    )}
    <Text>
      You can link your membership number here to the quote, or later on the
      Review Summary page before purchase.
    </Text>
  </>
);

export { FlybuysHelpText };
